/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const foodMythsPizza = useStore((state) => state.foodMythsPizza);
  const setFoodMythsPizza = useStore((state) => state.setFoodMythsPizza);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.foodMythsPizza.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={foodMythsPizza}
          onChange={(value) => {
            setFoodMythsPizza(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'food-myths-pizza',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Yes, it makes you gain weight'}>
            <span>🍕</span> {t('onboarding.foodMythsPizza.options.makesGainWeight')}
          </Option>
          <Option value={'Better to avoid it'}>
            <span>🚫</span> {t('onboarding.foodMythsPizza.options.betterAvoid')}
          </Option>
          <Option value={"No, it's fine occasionally"}>
            <span>🙌</span> {t('onboarding.foodMythsPizza.options.fineOccasionally')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
